import { useEffect } from 'react';
import { useAnalytics } from '@backstage/core-plugin-api';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useCustomEntityAnalytics } from './useCustomEntityAnalytics';

export const useEntityPageAnalytics = () => {
  const { entity, loading, error } = useCustomEntityAnalytics();
  const analytics = useAnalytics();

  useEffect(() => {
    // エンティティがロード中、エラー、または存在しない場合は何もしない
    if (loading || error || !entity) {
      return;
    }

    const entityRef = stringifyEntityRef(entity);
    const { kind, metadata, spec } = entity;
    const entityType = (spec as any)?.type || 'unknown';

    // catalog_entity_viewイベントを送信
    // subject: {kind}_{type} (例: Group_team, Component_service)
    analytics.captureEvent('catalog_entity_view', `${kind}_${entityType}`, {
      value: 1,
      attributes: {
        entityRef,
        entityKind: kind,
        entityType,
        entityName: metadata.name,
        namespace: metadata.namespace || 'default',
      },
    });
  }, [entity, loading, error, analytics]);
};
